module.exports = require("./sr-Latn-XK.js");